// ── 3 Anmeldung ── Zustand und Rumpf (rein). Die Felder beider Verfahren
// stehen immer im Zustand (früher: im Formular, nur versteckt) und gehen immer
// mit; Geheimnisse nur, wenn etwas eingetippt ist.

import type { Catalog, Tenant } from "../../api/types";

export interface AuthState {
  modes: string[];
  entra_tenant_id: string;
  entra_client_id: string;
  entra_secret: string;
  issuer: string;
  client_id: string;
  oidc_secret: string;
  scopes: string;
  display_name: string;
}

export interface AuthBody {
  auth: {
    modes: string[];
    entra_tenant_id: string;
    entra_client_id: string;
    issuer: string;
    client_id: string;
    scopes: string;
    display_name: string;
  };
  secrets: { entra?: string; oidc?: string };
}

export function authFromTenant(t: Tenant): AuthState {
  const a = t.auth;
  return {
    modes: [...a.modes],
    entra_tenant_id: a.entra_tenant_id ?? "",
    entra_client_id: a.entra_client_id ?? "",
    entra_secret: "",
    issuer: a.issuer ?? "",
    client_id: a.client_id ?? "",
    oidc_secret: "",
    scopes: a.scopes ?? "",
    display_name: a.display_name ?? "",
  };
}

export function authToBody(s: AuthState, cat: Catalog): AuthBody {
  const secrets: AuthBody["secrets"] = {};
  if (s.entra_secret.trim()) secrets.entra = s.entra_secret.trim();
  if (s.oidc_secret.trim()) secrets.oidc = s.oidc_secret.trim();
  return {
    auth: {
      // Reihenfolge des Katalogs, und nur, was er kennt — wie die Checkboxen.
      modes: cat.auth_modes.filter((m) => s.modes.includes(m)),
      entra_tenant_id: s.entra_tenant_id, entra_client_id: s.entra_client_id,
      issuer: s.issuer, client_id: s.client_id, scopes: s.scopes, display_name: s.display_name,
    },
    secrets,
  };
}
